import { z } from 'zod';

export const zodDeleteCallOffAttachmentEndpointSchema = z.tuple([
  z.literal('calloffs'),
  z.uuid(),
  z.literal('attachments'),
  z.uuid(),
]);
